export enum EXERCISES_ACTION_NAMES {
  'LOAD_EXERCISES' = '[Exercises/API] LOAD_EXERCISES',
  'LOAD_EXERCISES_SUCCESS' = '[Exercises/API] LOAD_EXERCISES_SUCCESS',
  'LOAD_EXERCISES_FAILURE' = '[Exercises/API] LOAD_EXERCISES_FAILURE',

  'FIND_EXERCISES' = '[Exercises/API] FIND_EXERCISES',
  'FIND_EXERCISES_SUCCESS' = '[Exercises/API] FIND_EXERCISES_SUCCESS',
  'FIND_EXERCISES_FAILURE' = '[Exercises/API] FIND_EXERCISES_FAILURE',

  'REFRESH_EXERCISES' = '[Exercises/API] REFRESH_EXERCISES',
  'REFRESH_EXERCISES_SUCCESS' = '[Exercises/API] REFRESH_EXERCISES_SUCCESS',
  'REFRESH_EXERCISES_FAILURE' = '[Exercises/API] REFRESH_EXERCISES_FAILURE',

  'EMPTY_EXERCISES' = '[Exercises/Release Resource] EMPTY_EXERCISES',

  'EXERCISE_SAVED' = '[Exercises/ExerciseDetails] EXERCISE_SAVED',
  'EXERCISE_SAVED_SUCCESS' = '[Exercises/ExerciseDetails] EXERCISE_SAVED_SUCCESS',
  'EXERCISE_SAVED_FAILURE' = '[Exercises/ExerciseDetails] EXERCISE_SAVED_FAILURE',

  'DELETE_EXERCISE' = '[Exercises/API] DELETE_EXERCISE',
  'DELETE_EXERCISE_SUCCESS' = '[Exercises/API] DELETE_EXERCISE_SUCCESS',
  'DELETE_EXERCISE_FAILURE' = '[Exercises/API] DELETE_EXERCISE_FAILURE',

  'LOAD_EXERCISE_DETAILS' = '[Exercises/API] LOAD_EXERCISE_DETAILS',
  'LOAD_EXERCISE_DETAILS_SUCCESS' = '[Exercises/API] LOAD_EXERCISE_DETAILS_SUCCESS',
  'LOAD_EXERCISE_DETAILS_FAILURE' = '[Exercises/API] LOAD_EXERCISE_DETAILS_FAILURE',
  'RELEASE_EXERCISE_DETAILS' = '[Exercises/Release Resource] RELEASE_EXERCISE_DETAILS',

  'OPEN_EXERCISE_DETAILS_DIALOG' = '[Exercises/UI] OPEN_EXERCISE_DETAILS_DIALOG',
}
